import { gql } from '@apollo/client';

export const GET_WHATSAPP_ACCOUNT = gql`
  query GetWhatsAppAccount {
    whatsAppAccount {
      id
      agencyId
      phoneNumberId
      businessAccountId
      phoneNumber
      displayName
      isActive
      webhookVerified
      messagesCount
      templates {
        id
        name
        language
        content
        variables
        isDefault
        createdAt
      }
      createdAt
      updatedAt
    }
  }
`;

export const GET_WHATSAPP_MESSAGES = gql`
  query GetWhatsAppMessages($limit: Int, $offset: Int) {
    whatsAppMessages(limit: $limit, offset: $offset) {
      id
      recipientPhone
      recipientName
      messageType
      status
      waMessageId
      errorMessage
      deliveredAt
      readAt
      createdAt
      package {
        id
        title
        image
      }
    }
    whatsAppMessagesCount
  }
`;

export const GET_WHATSAPP_TEMPLATES = gql`
  query GetWhatsAppTemplates {
    whatsAppTemplates {
      id
      name
      language
      content
      variables
      isDefault
      createdAt
    }
  }
`;
